var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reports",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "statistics",
    transform: "translate(0.488 1.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    className: "cls-2",
    d: "M32.539,8.209A1.531,1.531,0,0,0,33.6,7.776l1.519.759a1.508,1.508,0,0,0-.019.187,1.539,1.539,0,1,0,3.078,0,1.52,1.52,0,0,0-.154-.659L40.089,6a1.52,1.52,0,0,0,.659.154,1.541,1.541,0,0,0,1.539-1.539,1.516,1.516,0,0,0-.077-.456L44,2.819a1.538,1.538,0,1,0-.687-1.28A1.516,1.516,0,0,0,43.39,2L41.6,3.337a1.532,1.532,0,0,0-2.237,1.94L37.3,7.337a1.512,1.512,0,0,0-1.725.278l-1.519-.759a1.508,1.508,0,0,0,.019-.187,1.539,1.539,0,1,0-1.539,1.539Zm0,0",
    transform: "translate(-29.94 0)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    className: "cls-2",
    d: "M17,161.355h-.547V150.513a.513.513,0,0,0-.513-.513H13.886a.513.513,0,0,0-.513.513v10.842H12.347v-7.764a.513.513,0,0,0-.513-.513H9.782a.513.513,0,0,0-.513.513v7.764H8.243V157.7a.513.513,0,0,0-.513-.513H5.678a.513.513,0,0,0-.513.513v3.66H4.139v-5.712a.513.513,0,0,0-.513-.513H1.573a.513.513,0,0,0-.513.513v5.712H.513a.513.513,0,0,0,0,1.026H17a.513.513,0,0,0,0-1.026Zm0,0",
    transform: "translate(0 -144.87)",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.5fea4fdd7e79c23a211991056d05cc09.svg";
export { ForwardRef as ReactComponent };